module.exports = __webpack_public_path__ + "img/DefaultStatus.eab5949b.svg";